import { isNil, mapKeys as mapKeysInternal, mapValues, omitBy, pick } from 'es-toolkit';

export const filter = <T>(
  array: readonly T[],
  predicate: (item: T, index: number, items: readonly T[]) => boolean
): T[] => {
  const result: T[] = [];
  // entries() ensures sparse arrays skip holes without additional undefined checks.
  for (const [index, value] of array.entries()) {
    if (predicate(value, index, array)) {
      result.push(value);
    }
  }
  return result;
};

export const some = <T>(
  array: readonly T[],
  predicate: (item: T, index: number, items: readonly T[]) => boolean
): boolean => {
  for (const [index, value] of array.entries()) {
    if (predicate(value, index, array)) {
      return true;
    }
  }
  return false;
};

export const map = <T, R>(array: readonly T[], mapper: (item: T, index: number, items: readonly T[]) => R): R[] => {
  const result: R[] = [];
  result.length = array.length;
  for (const [index, value] of array.entries()) {
    result[index] = mapper(value, index, array);
  }
  return result;
};

export const buildQueryParams = <T extends Record<string, string | number | boolean | null | undefined>>(
  object: T,
  allowedKeys?: (keyof T)[]
): URLSearchParams => {
  const filtered = allowedKeys === undefined ? object : pick(object, allowedKeys);
  const cleaned = omitBy(filtered, isNil);
  return new URLSearchParams(mapValues(cleaned, String));
};

export const mapKeys: typeof mapKeysInternal = (...arguments_) => mapKeysInternal(...arguments_);
